module.exports = __webpack_public_path__ + "img/ic_32_sport_fussball-white.09998cb9.svg";